class VatToggle extends HTMLElement {
  constructor() {
    super();
    this.vatToggle = this.querySelector('.vat-toggle input');
    this.vatLabel = this.querySelector('.vat-toggle-label');

    this.vatToggle.addEventListener('change', this.handleVatToggle.bind(this));

    this.loadVatState();

    const quickAddToCartEl = document.querySelector('quick-add-drawer');
    const cartRecommendationsEl = document.querySelector('#cart-recommendations');

    const onMutation = () => {
      console.log("Mutation")
      if (quickAddToCartEl?.querySelector('.price__current') || cartRecommendationsEl?.querySelector('.price__current')) {
        console.log("appeared")
        this.loadVatState();
      }
    }

    const quickAddToCartMutation = new MutationObserver(onMutation);
    const cartRecommendationsMutation = new MutationObserver(onMutation);

    quickAddToCartMutation.observe(quickAddToCartEl, { childList: true, subtree: true });
    cartRecommendationsMutation.observe(cartRecommendationsEl, { childList: true, subtree: true });
  }

  loadVatState() {
    if (window.sessionStorage.getItem('vat-included') === 'true') {
      this.includeVat();
    } else {
      this.excludeVat();
    }
  }

  handleVatToggle() {
    if (window.sessionStorage.getItem('vat-included') === 'true') {
      this.excludeVat();
    } else {
      this.includeVat();
    }
  }

  excludeVat() {
    this.vatToggle.checked = false;
    this.vatLabel.innerHTML = 'Excl VAT';
    window.sessionStorage.setItem('vat-included', 'false');

    const priceElements = document.querySelectorAll(".price__current__container");

    priceElements.forEach((price_container) => {
      const grossPrice = price_container.querySelector('.price__current__gross');
      const netPrice = price_container.querySelector('.price__current__net');

      grossPrice?.setAttribute('style', 'display: none;');
      netPrice?.setAttribute('style', 'display: block;');
    });
  }

  includeVat() {
    this.vatToggle.checked = true;
    this.vatLabel.innerHTML = 'Incl VAT';
    window.sessionStorage.setItem('vat-included', 'true');

    const priceElements = document.querySelectorAll(".price__current__container");

    priceElements.forEach((price_container) => {
      const grossPrice = price_container.querySelector('.price__current__gross');
      const netPrice = price_container.querySelector('.price__current__net');

      grossPrice?.setAttribute('style', 'display: block;');
      netPrice?.setAttribute('style', 'display: none;');
    });
  }

}

customElements.define('vat-toggle', VatToggle);